const TRANSACTIONS =
    Object.freeze(
        {
            DEFAULT_CREDITS_VALUE: 20,
            MIN_CREDITS_VALUE: 10,
        }
    );

export default TRANSACTIONS;
